<template>
  <div class="content">
    <div class="hover-content">
      <div class="hover-box">
        <div style="font-size: 16px;">
          <p style="font-size: 20px; font-weight: bold;">业务简介</p>
          <p style="text-indent: 2em; font-size: 16px; font-weight: normal;">公证认证“一站式”服务是指我省公民和企业可在全省以下75家公证处办理公证书的同时，一并申请代办领事认证服务。</p>
          <p style="font-size: 20px; font-weight: bold;">“一站式”服务公证处</p>
        </div>
        <a-input-search class="a-input" placeholder="请输入公证处名称" size="large" v-model="params.officeName" @search="(e) => {
          this.search(e)
        }">
          <a-button slot="enterButton" type="primary">
            <a-icon type="search" />搜索
          </a-button>
        </a-input-search>
        <a-button @click="reset" style="height: 41px; margin-left: 15px;">重置</a-button>
      </div>
      <div class="retrieval" style="margin: 20px 0 10px 0;text-align: left;">
        <span>区域检索：</span>
        <div class="retrieval-content" :style="`border-bottom: ${item.fullPathCode === regionCodeFullPath ? '2px solid #cbb486;' : ''}`" v-for="(item) in newtagList" :key="item.regionName" @click="getOneStopShop({ regionCodeFullPath: item.fullPathCode })">
          <span>{{item.regionName}}</span>
        </div>
      </div>

      <div class="content-item">
        <div class="item-content" v-for="(item) in departmentList" :key="item.key">
          <div style="display: flex">
            <img src="../../../assets/images/icon_identification_notarization_logo1.png" style="height: 80px;width: 80px;margin-left: 42px;margin-top: 45px;vertical-align:middle;" />
            <div style="vertical-align:middle;margin-left: 33px; text-align: left;">
              <p class="item-title" style="margin-bottom: 20px">{{ item.officeName }}</p>
              <div style="display: flex;">
                <div class="item-left">
                  <p>联系电话:</p>
                  <p>机构地址:</p>
                </div>
                <div class="item-right">
                  <p>{{ item.officeMobile }}</p>
                  <p style="padding-bottom: 20px">{{ item.officeAddress }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="text-align: center;margin-top: 20px;height: 30px;">
          <a-pagination showQuickJumper showSizeChanger :pageSizeOptions="pageSizeOptions" :pageSize="pageSize" :total="total" :showTotal="(total) => `总共 ${total} 条`" :itemRender="itemRender" @change="onChange" @showSizeChange="onShowSizeChange">
          </a-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getOneStopShop, // 获取一站式
  getArea, // 获取中国区域
} from '@/api/consularCertification'
export default {
  name: 'middle-content',
  data () {
    return {
      name: '',
      list: [],
      total: 0,
      params: { officeName: '' },
      current: 2,
      departmentList: [],
      pageSizeOptions: ['6', '20', '30'],
      tagList: [],
      newtagList:[ { "regionCode": "350000", "regionName": "福建省", "fullPathCode": "350000", "level": 1 },
 { "regionCode": "350100", "regionName": "福州市", "fullPathCode": "350000.350100", "level": 2 }, 
{ "regionCode": "350200", "regionName": "厦门市", "fullPathCode": "350000.350200", "level": 2 },
{ "regionCode": "350600", "regionName": "漳州市", "fullPathCode": "350000.350600", "level": 2 }, 
 { "regionCode": "350500", "regionName": "泉州市", "fullPathCode": "350000.350500", "level": 2 }, 
{ "regionCode": "350400", "regionName": "三明市", "fullPathCode": "350000.350400", "level": 2 },
 { "regionCode": "350300", "regionName": "莆田市", "fullPathCode": "350000.350300", "level": 2 }, 
{ "regionCode": "350700", "regionName": "南平市", "fullPathCode": "350000.350700", "level": 2 },
 { "regionCode": "350800", "regionName": "龙岩市", "fullPathCode": "350000.350800", "level": 2 }, 
{ "regionCode": "350900", "regionName": "宁德市", "fullPathCode": "350000.350900", "level": 2 }, 
{ "regionCode": "350128", "regionName": "平潭综合实验区", "fullPathCode": "350000.350100.350128", "level": 3 } ],
      pageSize: 6
    }
  },
  created () {
    this.getArea()
    this.getOneStopShop({ regionCodeFullPath: "350000" })
    console.log('this.tagList',this.tagList)
  },
  methods: {
    reset () {
      this.params = {}
      this.getOneStopShop()
    },
    getArea () {
      getArea().then(res => {
        this.tagList = this._.get(res, 'data.records', [])
          .filter(item => {
            return (item.level === 1 || item.level === 2 || item.regionCode === '350128')
          }).sort((a, b) => a.level - b.level)
      })
      
    },
    getOneStopShop (params) {
      this.params = { ...this.params, ...params }
      console.log(this.params);
      this.regionCodeFullPath = this.params.regionCodeFullPath
      getOneStopShop(this.params).then(res => {
        this.departmentList = this._.get(res, 'data.records', [])
        this.total = this._.get(res, 'data.total')
        console.log(this.departmentList, this.total, this.pageSize);
      })
    },
    search (officeName) {
      this.params.officeName = officeName
      this.getOneStopShop(this.params)
    },
    onChange (pageNumber) {
      this.getOneStopShop({ pageNo: pageNumber })
    },
    onShowSizeChange (current, pageSize) {
      // this.page = current;
      // this.pageSize = pageSize;
      // this.getList();
      this.pageSize = pageSize
      this.getOneStopShop({ pageNo: current, pageSize: pageSize })
    },
    itemRender (current, type, originalElement) {
      if (type === 'prev') {
        return <li class="ant-pagination-item"><a>上页</a></li>;
      } else if (type === 'next') {
        return <li class="ant-pagination-item"><a>下页</a></li>;
      }
      return originalElement;
    },
  }
}
</script>

<style scoped lang='less'>
/deep/ .ant-btn:hover {
  color: #decba4;
  background-color: #fff;
  border-color: #decba4;
}
/deep/ .ant-btn:focus {
  color: #decba4;
  background-color: #fff;
  border-color: #decba4;
}
/deep/ .ant-table-tbody > tr > td {
  padding: 0;
}
.fire-box:not(:last-of-type) {
  border-bottom: 1px solid #e5e5e5;
}
.content {
  width: 100%;
  position: relative;
  margin-bottom: 40px;
  margin-top: 59px;
  &-box {
    width: 1140px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    text-align: left;
    font-size: 0px;
  }
}
.box:not(:last-of-type) {
  margin-right: 27px;
}
.box:hover {
  border: 1px solid #decba4;
  box-shadow: 0px 0px 20px 4px rgba(222, 203, 164, 0.32);
}
.box {
  width: 264px;
  height: 260px;
  display: inline-block;
  border: 1px solid #e5e5e5;
  box-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.04);
  text-align: center;
  cursor: pointer;
  position: relative;
  img {
    width: 64px;
    height: 64px;
    margin-top: 61px;
  }
  p {
    margin: 0;
    padding: 0;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    margin-top: 23px;
  }
  .p:hover {
    color: #cbb486;
  }
  .p {
    margin-top: 22px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #7f7f7f;

    span {
      color: #7f7f7f;
    }
    span:hover {
      color: #cbb486;
    }
  }
}
.hover-content {
  width: 1140px;
  /* height: 394px; */
  /* display: flex; */
  justify-content: space-between;
  //padding: 48px;
  //border: 1px solid #DECBA4;
  //box-shadow: 0px 0px 20px 4px rgba(222, 203, 164, 0.32);
}
.hover-box {
  flex: 100%;
  text-align: left;
  p {
    padding: 0;
    margin: 0;
    padding-bottom: 15px;
  }
  div:hover {
    color: #cbb486;
  }
  div:hover .down-btn {
    display: inline-block;
  }
  .boxx {
    margin: 0;
    padding: 0;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #3d4652;
    line-height: 68px;
    border-bottom: 1px solid #eee;
    padding-left: 15px;
    position: relative;
    white-space: nowrap;
    .down-btn {
      line-height: 36px;
      color: #cbb486;
    }
    img {
      line-height: 36px;
      margin-top: 0px;
    }
  }
  .boxx::before {
    content: "";
    display: inline-block;
    border-radius: 50%;
    width: 5px;
    height: 5px;
    background: rgba(203, 180, 134, 1);
    position: absolute;
    left: -1px;
    top: 31px;
  }
  .retrieval {
    width: 100%;
    margin-top: 20px;
    display: flex;
    text-align: left;
    margin-top: 25px;
    span {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #7f7f7f;
      line-height: 28px;
      vertical-align: middle;
    }
  }
}
.retrieval-content {
  cursor: pointer;
  display: inline-block;
  width: auto;
  padding: 0 15px;
  line-height: 32px;
  vertical-align: middle;
  span {
    color: #3a3a3a;
  }
}
.retrieval-content:hover {
  background: #cbb486;
  color: #ffffff;
  span {
    color: #ffffff;
  }
}
.hover-box:first-of-type {
  margin-right: 40px;
}
.down-btn {
  display: inline-block;
  display: none;
  width: 100px;
  height: 40px;
  border-radius: 20px;
  background: #ffffff;
  border: 1px solid #cbb486;
  vertical-align: middle;
  text-align: center;
  img {
    width: 16px;
    height: 16px;
  }
}
.more {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #cab484;
  /* position: absolute; */
  bottom: 56px;
  left: 50%;
  transform: translateX(-50%);
}
.hover-title {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #1d1d1f;
}
.hover-desc {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  p {
    color: rgba(61, 70, 82, 1);
    font-size: 16px;
  }
}
.hover-content {
  .hover-address {
    color: rgba(61, 70, 82, 1);
    font-size: 16px;
    padding-top: 15px;
    span {
      color: rgba(24, 144, 255, 1);
    }
  }
}

.a-input {
  width: 520px;
  /deep/.ant-input-group-addon,
  /deep/.ant-btn {
    width: 120px;
    height: 40px;
    background: #cbb486;
    border-radius: 0px 4px 4px 0px;
    border-color: #cbb486;
  }
  /deep/.ant-input {
    width: 400px;
    height: 40px;
    background: #ffffff;
    border: 1px solid #cbb486;
    border-radius: 4px 0px 0px 4px;
  }
}
.a-table-c {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #1d1d1f;
}
/deep/.ant-input:focus {
  outline: none;
  box-shadow: none !important;
}
</style>
<style scoped lang='less'>
.content-item {
  margin: 2px 0 0 -15px;
  width: 1142px;
  text-align: left;
  .item-content {
    margin-top: 20px;
    margin-right: 15px;
    margin-left: 15px;
    width: 505px;
    min-height: 175px;
    height: auto;
    background: #ffffff;
    border: 1px solid #e5e5e5;
    display: inline-block;
    .item-title {
      height: 18px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #3a3a3a;
      line-height: 28px;
    }
    .item-left {
      width: 61px;
      height: 44px;
      margin-right: 6px;
    }
    .item-right {
      width: 234px;
      height: 64px;
    }
    .item-left p,
    .item-right p {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #7f7f7f;
      display: inline-block;
      vertical-align: middle;
      margin-bottom: -10px;
    }
  }
  .item-content:hover {
    border: 1px solid #cdad7f;
    box-shadow: 0px 0px 20px 4px rgba(222, 203, 164, 0.32);
  }
}
/deep/.ant-pagination-disabled,
.ant-pagination-disabled:hover,
.ant-pagination-disabled:focus {
  cursor: not-allowed;
  display: none;
}
/deep/.ant-pagination-item-active a {
  color: #ffffff;
  background-color: #cbb486;
}
/deep/.ant-pagination-item-active {
  border-color: #cbb486;
}
/deep/.ant-pagination a:hover {
  color: #cbb486;
}
/deep/.ant-pagination li:hover {
  border-color: #cbb486;
}
.img-list {
  display: block;
  margin-bottom: 20px;
  padding: 0;
  img {
    width: 800px;
    height: auto;
    display: block;
    margin: 0 auto;
    padding: 0;
  }
}
/deep/ .ant-table-placeholder {
  height: 100px;
}
/deep/ .ant-empty-normal {
  margin: 12px 0;
}
.type-af::after {
  content: "";
  display: inline-block;
  width: 1px;
  height: 55px;
  background: #e5e5e5;
  position: absolute;
  top: 1px;
  right: 163px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/selfComponents/yizhanshi.vue